define([], function() {
var unifiedapplepay = {
		paymentRequest:null,
		errorKeys: ['ERR_AP_COUNTRY_NOTVALID','ERR_AP_AUTH_FAILED','ERR_AP_MAX_AUTH_FAILED','ERR_AP_PAYMENT_SYSTEM_DOWN','ERR_AP_INVALID_PHONE'],
		
		showUnifiedApplePaySection: function() {
			if(COSTCO.unifiedapplepay.isUnifiedApplePayEnabled()){
				COSTCO.unifiedapplepay.showApplePaySection();
				if($('#checkOutStepNumber').val() == '3'){
					COSTCO.unifiedapplepay.renderApplePayPaymentSheet();
				}
			}
		},
		
		showApplePaySection: function() {
	      $('input[id=appliedPayMethod]').val('');
	      $('input[id=isApplePaySheetSubmitted]').val('');
	      $('input[id=unifiedPaymentType]').val('');
	      $('#save_CC').prop('checked', false);
	      $('#radio-credit-card').prop('checked', false);
	      $('#radio-applepay').prop('checked', true);
	      COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), false);
	      $('[data-payment-type-element="true"]').each(function() {
	    	  this.setAttribute("aria-checked", "false");
	      });
	      $('#radio-applepay-ada-handler').attr('aria-checked', true);
	      
	      $('#cc-payment-block').addClass('hide');
	      $('#cc-payment-address-block').addClass('hide'); 
	      $('#address-container-billing').addClass('hide');
	      $('#wallet-edit-link').addClass('hide');
	      $('#clickpay-payment-block').addClass('hide');
	      $('#applepay-payment-block').removeClass('hide');
	      //$('#place-order-button-applepay').removeClass('hide');
	      if($('#checkOutStepNumber').val() == '3'){
	        	$('#place-order-button-applepay').removeClass('hide');
	        	$('#place-order-button-regular').addClass('hide');
	        	//createUnifiedTokenSessionId();
	         }   
	      // Remove error messages if wallet section is deselected.
	      COSTCO.wallet.hideErrorBox();
	      COSTCO.wallet.hideErrorMessage(); 
	      
	      if(COSTCO.Checkout.displayAllPayments()){
	    	  $('#clicktopay-block-form').addClass('hide');
	          $('#wallet-payment-address-block').addClass('hide');
	      }
	    },
	    
	    submitPaymentStep: function() {
	    	 let form = COSTCO.CreditCard.forms.creditCardForm();
    	 	  $(form).find('input[name=payMethodId]').val("UnifiedApplePay");
		      $(form).find('input[name=walletProvider]').val("SECURE_REMOTE_COMMERCE");
		      $(form).find('input[name=unifiedPaymentType]').val("UnifiedApplePay");
		      $('[name=walletCheckout]').attr('value', 'false');

		      if (typeof COSTCO.MembershipHelper !== 'undefined' && COSTCO.MembershipHelper.isQuickMembership) {
			      let $form = COSTCO.CreditCard.forms.creditCardForm();
	             $form.attr('action', 'CostcoBillingPayment');
	           	let ftcAutoRenewConsentObj = $form.find('input[name=isPurchaseMembershipAutoRenew]');
	           	if(ftcAutoRenewConsentObj.length > 0)
	           		$form.find('input[name=URL]').val('OrderPrepare?URL=QuickMembershipCheckoutCmd?isTandCAccepted=true%26isPurchaseMembershipAutoRenew='+ftcAutoRenewConsentObj.val());
	           	else
	           		$form.find('input[name=URL]').val('OrderPrepare?URL=QuickMembershipCheckoutCmd?isTandCAccepted=true');
	           }
		    $(form).find('input[name=tokenSessionId]').val('');
		    $(form).find('input[name=microformCaptureContext]').val('');
		    $(form).find('input[name=piAmount]').val('0.0');
		    COSTCO.CreditCard.submit.creditCardForm();
           
	    },
	    
	    isApplePaySelected: function() {
			return $('#applepay-block input[name=\'payment-radio\']').is(':checked');
		},
		isApplePayApplied: function() {
	    	return ($('input[id=usedPayMethod]').length > 0 && $('input[id=usedPayMethod]').val() == 'applepay');
		},
		isApplePayUsed: function() {
		   	return ($('#applepay-info-container').length > 0 && !$('#applepay-info-container').hasClass('hide'));
		},
		isUnifiedApplePayEnabled: function() {
	    	return ($('input[name=unifiedApplePayEnabled]').length > 0 && $('input[name=unifiedApplePayEnabled]').val() == 'true');
		},
		setUnifiedApplePayBtnTimer: function() {
			if($('input[name=unifiedApplepayButtonTimer]').length > 0){
				const timer = $('input[name=unifiedApplepayButtonTimer]').val();
				if(timer != null && timer.trim() != "" && !isNaN(Number(timer))){
					setTimeout(() => { COSTCO.unifiedapplepay.displayApplePayRefrshPageError(); }, Number(timer) * 60 * 1000);
				}
			}
		},
		isCustomFlow: function(){
			if(COSTCO.unifiedapplepay.isUnifiedApplePayEnabled() && COSTCO.unifiedapplepay.isApplePaySelected() && COSTCO.unifiedapplepay.isApplePayApplied()){
				return false;
			} else {
				return false;
			}
		},
		renderApplePayPaymentSheet: function() {
	    	if(COSTCO.unifiedapplepay.isUnifiedApplePayEnabled() && COSTCO.unifiedapplepay.isApplePaySelected()){
	    		COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep($('input[id=checkOutStepNumber]').val());
	    	}
	    },
	    processApplePayErrorMessages: function(errorVal) {
		  	if(typeof errorVal != 'undefined'){
		  		$('#radio-applepay-ada-handler').click();
				let msg = null;
				if(errorVal == 'ERR_AP_COUNTRY_NOTVALID'){
					msg = messages.ERR_AP_COUNTRY_NOTVALID;
				} else if(errorVal == 'ERR_AP_INVALID_PHONE'){
					msg = messages.ERR_AP_INVALID_PHONE;
				} else if(errorVal == 'ERR_AP_AUTH_FAILED'){
					msg = messages.ERR_AP_AUTH_FAILED;
					COSTCO.unifiedapplepay.focusOnApplePayError();
				} else if(errorVal == 'ERR_AP_PAYMENT_SYSTEM_DOWN'){
					msg = messages.ERR_AP_PAYMENT_SYSTEM_DOWN;
					COSTCO.unifiedapplepay.focusOnApplePayError();
				} else if(errorVal == 'ERR_AP_MAX_AUTH_FAILED'){
					msg = messages.ERR_AP_MAX_AUTH_FAILED;
					COSTCO.unifiedapplepay.focusOnApplePayError();
				}
				if(msg != null){
					COSTCO.util.announceSRMessage(msg);
				}
		  	}
	  },
	  
	  displayApplePayRefrshPageError: function() {
		  var errMsg = messages.CHECKOUT_REFRESH_CYBERSOURCE;
		  errMsg = `<msg-text>${errMsg}</msg-text>`;
		  var htmlContent =`<p class="error errorTop critical-notification order-error" role="alert" automation-id="shippingRestriction">
			  				<span class="co-info info" data-original-title="" title=""></span>
			  				${errMsg} 
			  				</p>`;
		  if ($('.errorTop').length > 0) {
			  $('.errorTop').html(`<span class="co-info info" data-original-title="" title=""></span>`+errMsg);
		  } else {
			  $('#notification-message').html(htmlContent);
		  }
		
		COSTCO.unifiedapplepay.focusOnApplePayError();
		window.digitalDataEvents = window.digitalDataEvents || [];
		digitalDataEvents.push( {uimsg:"Checkout Flow | Please refresh your page to continue checkout" } );
	  },
	  
	  focusOnApplePayError: function() {
		  if ($('.error_check').length > 0) {
			var errors = document.getElementsByClassName('errorTop');
			setTimeout(() => { $(window).scrollTop(0); errors[0].focus(); }, 300);
		  }
	  }
	};

   
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	} 
    window.COSTCO.unifiedapplepay = unifiedapplepay;
    return unifiedapplepay;
});



// WEBPACK FOOTER //
// ./js/checkout/unifiedapplepay.js